<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="checkbox" name="state" :options="stateArray"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button  icon="add"color="sys" @click="create()">添加</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:darkgreen;">启用</span>
                        <span v-if="data.state == 1" style="color:red;">禁用</span>
                    </template>
                </c-table-column>

<!--                <c-table-column
                        label="封面图"
                        name="image"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.image" size="60"></c-image>
                    </template>
                </c-table-column>-->

                <c-table-column
                    label="标题"
                    name="title"
                    width="250"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        power="m_news_list"
                        @sort="sortHandle"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="edit(data)">编辑</c-table-button>
                        <c-table-button @click="del(data)">删除</c-table-button>
                        <c-table-button v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
                        <c-table-button v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑张博士谈标品' : '添加张博士谈标品'" width="1200" height="650" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="hidden" name="language_type"></c-form-item>
<!--
                <c-form-item type="image" label="封面图" name="image" required file-word="建议尺寸：960×420px"></c-form-item>
-->
                <c-form-item type="input" label="标题" name="title" required></c-form-item>
                <c-form-item type="datetime" date-type="datetime" label="发布时间" name="publish_date" readonly required></c-form-item>
                <c-form-item type="editor" label="内容" name="content" required></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
export default {
    name: 'm_standard_substance',
    props: {
        languageType: Number        //2=英文  1=中文
    },
    data() {
        return {
            currentTime:'',
            dataType:3,         //3:表示 张博士谈标准品
            stateArray: [
                {name: '禁用',value:1},
                {name: '启用',value:2}
            ],
            languageArray: [
                {name: '中文',value:1},
                {name: '英文',value:2}
            ],
            languageOption:[
                {name: '中文',value: 1},
                {name: '英文',value: 2}
            ],
            editState: false
        }
    },

    mounted() {
        this.$refs.search.search();
        this.getCurrentTime();
    },

    methods: {
        getCurrentTime() {
            //获取当前时间并打印
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            this.currentTime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
        },

        searchHandle(data) {
            data.language_type = this.languageType;
            this.$refs.table.load({
                url: '/website/standard_substance/list',
                data
            });
        },

        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData ={};
            if(type=='top' || type=='bottom'){
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if(type=='up'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if(type=='down'){
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/website/standard_substance/sort',
                data: submitData,
                loading: true,
                success: data => {
                    next();
                }
            });
        },

        create() {
            this.editState = false;
            this.$refs.editForm.clear();
            this.$refs.editForm.set({
                language_type:this.languageType,
                content:' ',
                publish_date:this.currentTime
            });
            this.$refs.editDialog.open();
        },

        edit(val) {
            this.editState = true;
            this.$refs.editForm.clear();
            this.request({
                url: '/website/standard_substance/detail',
                data: {id:val.id},
                loading: true,
                success: data => {
                    this.$refs.editForm.set(data);
                    this.$refs.editDialog.open();
                }
            });
        },

        del(val) {
            this.$confirm({
                text: '确定要删除当前Banner吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/website/standard_substance/remove',
                        data: {id:val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        updateState(type,val) {
            this.$confirm({
                text: '确定要'+(type==2?'启用':'禁用')+'当前Banner数据？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/website/standard_substance/update_state',
                        data: {id:val.id,state:type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        submitForm(stop) {
            stop();
            let submitUrl = '/website/standard_substance/add';
            if(this.editState){
                submitUrl = '/website/standard_substance/edit';
            }
            this.$refs.editForm.submit({
                url: submitUrl,
                rule: {
                    publish_date: [{
                        type: 'empty',
                        word: '请填写发布时间'
                    }],
                    title: [{
                        type: 'empty',
                        word: '请填写标题'
                    }],
                    content: [{
                        type: 'empty',
                        word: '请填写内容'
                    }]
                },
                dataFormatter: data => {
                    var extra_data_map = {};
                    extra_data_map.publish_date = data.publish_date||'';
                    data.extra_data_map = extra_data_map;
                    data.language_type = this.languageType;
                    return data;
                },
                success:(data,res) => {
                    this.$message({
                        text: '操作成功',
                        icon: 'success'
                    });
                    this.$refs.table.update();
                    this.$refs.editDialog.close();
                },
            });
        }
    }
}
</script>